module.exports = __webpack_public_path__ + "img/11040609000372.706fc538.png";